<h2
  [class.mb-5]="isExpanded()"
  class="text-2xl font-bold flex justify-between items-center w-full text-grey-0 gap-6"
>
  <span>Driver du denna mottagning?</span>

  <app-ui-icon
    (click)="toggleExpand()"
    [name]="isExpanded() ? 'chevron_collapse' : 'chevron_expand'"
    color="#202225"
  ></app-ui-icon>
</h2>

@if (isExpanded()) {
  <div class="text-base">
    <p class="mb-5">
      Du som vårdgivare kan välja att synas på
      <a href="http://www.varden.se/">Vården.se</a> för fler patienter och ökad
      synlighet för din mottagning. Läs mer genom att trycka på knappen!
    </p>

    <app-ui-button
      [linkTitle]="'Jag vill synas på Vården.se'"
      [linkUrl]="'https://vardgivare.varden.se/'"
      class="test-become-customer-link"
      color="green"
      size="md"
      title="Jag vill synas på Vården.se"
    >
      Anslut din mottagning här
    </app-ui-button>
  </div>
}

